import { useRouter } from 'next/router';
import React from 'react';
import DetailsPage from './DetailsPage';

export const VideoEntry = ({ videoId, isTitle = false }) => {
    const router = useRouter();
    const openModal = Boolean(router.query.modalId);

    return (
        <>
            <DetailsPage id={videoId} openModal={openModal} isTitle={isTitle} />
        </>
    );
};

export default VideoEntry;
